import MobileAppsContainer from 'components/MobileApps/MobileAppsContainer'
import MobileAppsData from 'components/MobileApps/MobileAppsData'
import MobileAppsPresentation from 'components/MobileApps/MobileAppsPresentation'

export default {
  Container: MobileAppsContainer,
  Data: MobileAppsData,
  Presentation: MobileAppsPresentation,
}
